export const buildRedirectUrl = (metaSiteId?: string): string => {
  if (!metaSiteId) {
    return 'https://manage.wix.com/';
  }
  return `https://manage.wix.com/dashboard/${metaSiteId}`;
};

export const getUpgradeCompleteGTMConfig = (metaSiteId?: string) => ({
  metaSiteId,
  flow: 'ai-create-store' as const,
});
